import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { isUserRole } from "@examspark/common";
import {
  useQueryGetDefaultWorkspaceCalendar,
  useAppContext,
} from "@examspark/common-app";
import { Button } from "@examspark/common-ui";
import { LinkButton } from "@examspark/common-ui/dist/components/buttons/Button";
import {
  IconGearLine,
  IconNewWindowLine,
} from "@examspark/common-ui/dist/components/icons";
import { WorkspaceUserRole } from "@examspark/types";

import SidebarCalendarLabel from "../calendar/SidebarCalendarLabel";
import {
  ClassroomCalendarMonth,
  StyledCalendar,
} from "../classroom/planners/ClassroomPlannerCalendar";
import SidebarBox from "../common/SidebarBox";

import PlannerDayViewModal from "./PlannerDayViewModal";

const Wrapper = styled(SidebarBox)`
  overflow: hidden;
`;

const CenteredCalendar = styled(StyledCalendar)`
  display: flex;
  justify-content: center;
`;

const DashboardPlanner = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState<Date>(new Date());
  const [isDayModalOpen, setIsDayModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>();

  const [context] = useAppContext();
  const calendar = useQueryGetDefaultWorkspaceCalendar(
    context.workspaceUser?.workspace?.id,
  ).data;

  const canManageCalendars = isUserRole(
    context.workspaceUser,
    WorkspaceUserRole.ContentManager,
  );

  return (
    <>
      <Wrapper
        title="Calendar"
        toolbar={
          <>
            {canManageCalendars && (
              <LinkButton to="/calendar" variant="outlined">
                <IconGearLine width="16" />
              </LinkButton>
            )}
            <Button
              title="View District Calendar"
              variant="outlined"
              onClick={() => navigate("/workspace/calendars")}
            >
              <IconNewWindowLine width="16" />
            </Button>
          </>
        }
      >
        {!!calendar && <SidebarCalendarLabel calendar={calendar} />}
        <PlannerDayViewModal
          isOpen={isDayModalOpen}
          onRequestClose={() => setIsDayModalOpen(false)}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <CenteredCalendar>
          <ClassroomCalendarMonth
            month={month}
            // fake a course calendar
            courseCalendar={{
              calendar,
              units: [],
              additionalNonInstructionDates: [],
            }}
            onMonthChange={(month) => setMonth(month)}
            onClickDay={(value) => {
              setSelectedDate(value);
              setIsDayModalOpen(true);
            }}
          />
        </CenteredCalendar>
      </Wrapper>
    </>
  );
};

export default DashboardPlanner;
